import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, ElementRef, OnInit } from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { DateAdapter } from '@angular/material/core';
import { ErrorText } from 'src/app/enums/error-text.enum';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { ApiService } from 'src/app/services/api.service';
import * as moment from 'moment';

@Component({
  selector: 'fury-article-add-edit',
  templateUrl: './article-add-edit.component.html',
  styleUrls: ['./article-add-edit.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class ArticleAddEditComponent implements OnInit {

  articleId!: string;
  homeownerarticleform!: FormGroup;
  imagestoupload: any;
  todayDate: Date = new Date();
  editorConfig = {
    allowedContent: false,
    toolbarGroups: [
      { name: 'clipboard', groups: ['clipboard', 'undo'] },
      { name: 'editing', groups: ['find', 'selection', 'spellchecker'] },
      { name: 'links' }, { name: 'insert' },
      { name: 'document', groups: ['mode', 'document', 'doctools'] },
      { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
      { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
      { name: 'styles' },
      { name: 'colors' }
    ],
    forcePasteAsPlainText: true,
    image_previewText: ' '
  };
  homeownerCategorylist: any;
  authorList: any;

  constructor(
    public apiService: ApiService,
    private activatedroute: ActivatedRoute,
    public location: Location,
    private dateAdapter: DateAdapter<Date>,
    private router: Router,
    private el: ElementRef,
  ) {
    this.forminIt();

    this.dateAdapter.setLocale('en');
  }

  ngOnInit() {
    this.homeownerarticleform.get('title')?.valueChanges.subscribe((res: any) => {
      if (res) {
        this.homeownerarticleform.patchValue({
          slug: res.split(' ')?.join('-')
        });
      }
    });

    this.activatedroute.params.subscribe((res: any) => {
      if (res?.id) {
        this.articleId = res.id;
        this.getArticleDetails(this.articleId);
      }
    });
    this.getCategoryList();
    this.getAuthorList();
  }

  forminIt() {
    this.homeownerarticleform = new FormGroup({
      publishDate: new FormControl(new Date(), [Validators.required]),
      metaTitle: new FormControl('', [Validators.required]),
      metaDescription: new FormControl('', [Validators.required]),
      title: new FormControl('', [Validators.required]),
      bannerImage: new FormControl(''),
      bannerImageThumbnail: new FormControl(''),
      bannerImageAlternateText: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required]),
      homeOwnerCategoryIds: new FormControl([], [Validators.required]),
      authorId: new FormControl('', [Validators.required]),
      slug: new FormControl('', [Validators.required]),
      websiteStatus: new FormControl('', ),
    });
  }

  getArticleDetails(articleId: string) {
    this.apiService.get(`admin/home-owner/article/get-home-owner-article/${articleId}`).subscribe((res: any) => {
      if (res.body) {
        const {
          title,
          description,
          metaTitle,
          metaDescription,
          bannerImage,
          bannerImageThumbnail,
          publishDate,
          bannerImageAlternateText,
          categories,
          author,
          websiteStatus
        } = res.body.article;
        this.homeownerarticleform.patchValue({
          title,
          description,
          metaTitle,
          metaDescription,
          publishDate,
          bannerImageAlternateText,
          homeOwnerCategoryIds: categories.map((item: any) => item.homeOwnerCategoryId),
          authorId: author.authorId,
          websiteStatus
        });
        this.imagestoupload = bannerImageThumbnail;
      }
    }, err => {
      this.apiService.alert(err.error.message, ErrorType.Error);
      this.location.back();
    });
  }

  onImageUpload(event: any) {
    this.apiService.imageResize(event, 602, 311).then((dataURl: any) => {
      this.imagestoupload = dataURl;
      fetch(dataURl)
      .then(res => res.blob())
      .then(blob => {
        this.homeownerarticleform.patchValue({bannerImageThumbnail: new File([blob], event.target.files[0].name, { type: blob.type })})
      })
    })

    this.apiService.imageResize(event, 1358, 400).then((dataURl: any) => {
      fetch(dataURl)
        .then(res => res.blob())
        .then(blob => {
          this.homeownerarticleform.patchValue({ bannerImage: new File([blob], event.target.files[0].name, { type: blob.type }) });
        })
    })







    return;
    if (event.target.files[0].type === 'image/jpeg' || event.target.files[0].type === 'image/png' || event.target.files[0].type === 'image/jpg') {
      let file;
      file = event.target.files[0];
      this.homeownerarticleform.patchValue({ bannerImage: file });
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imagestoupload = e.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    } else {
      this.apiService.alert(ErrorText.ImageRestriction, 'error');
    }
  }

  getCategoryList() {
    this.apiService.get(`admin/home-owner/category/get-all-home-owner-categories?page=1&size=100`).subscribe((res: any) => {
      if (res.body) {
        this.homeownerCategorylist = res.body.homeOwnerCategories.data;
      } else {
      }
    }, err => {
      if (err) {
        this.apiService.alert(ErrorText.SomeThingWentWrong, ErrorType.Error);
      }
    });
  }

  getAuthorList() {
    this.apiService.get(`admin/author/get-all-authors?page=1&size=100`).subscribe((res: any) => {
      if (res.body) {
        this.authorList = res.body.authors.data;
      } else {
      }
    }, err => {
      if (err) {
        this.apiService.alert(ErrorText.SomeThingWentWrong, ErrorType.Error);
      }
    });
  }

  submit() {
    if (this.homeownerarticleform.valid) {
      if (this.imagestoupload) {
        const data = new FormData();

        Object.keys(this.homeownerarticleform.value).forEach((fieldName: any) => {
          if (this.homeownerarticleform.controls[fieldName] && fieldName === 'homeOwnerCategoryIds') {
            for (let i = 0; i < this.homeownerarticleform.value[fieldName].length; i++) {
              data.append(`homeOwnerCategoryIds[${i}]`, this.homeownerarticleform.value[fieldName][i]);
            }
          } else if (this.homeownerarticleform.controls[fieldName] && fieldName === 'publishDate') {
            data.append(fieldName, moment(this.homeownerarticleform.value[fieldName]).format('yyyy-MM-DD'));
          } else if(this.homeownerarticleform.controls[fieldName] && fieldName === 'websiteStatus'){
            if(this.homeownerarticleform.controls[fieldName].value){
              data.append('websiteStatus', '1')
            } else {
              data.append('websiteStatus', '0')
            }
          } else {
            data.append(fieldName, this.homeownerarticleform.value[fieldName]);
          }
        })


        const url = this.articleId ? `admin/home-owner/article/update-home-owner-article/${this.articleId}` : 'admin/home-owner/article/create-home-owner-article';

        this.apiService.postMultiData(url, data).subscribe(res => {
          if (res.body) {
            this.apiService.alert(res.body.message, ErrorType.Success);
            this.location.back();
          } else {
            this.apiService.alert(res.body.message, ErrorType.Warning)
          }
        }, err => {
          if (err) {
            Object.keys(err.errors).map((error) => {
              this.apiService.alert(err.errors[error], ErrorType.Error);
            })
          }
        })
      } else {
        this.apiService.alert(ErrorText.PleaseUploadTheImage, ErrorType.Error);
      }
    } else {
      this.homeownerarticleform.markAllAsTouched();
      const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector("input.ng-invalid");
      const textAreaInvalidControl: HTMLElement = this.el.nativeElement.querySelector("textarea.ng-invalid");
      if(firstInvalidControl){firstInvalidControl.focus()} 
      if(!firstInvalidControl && textAreaInvalidControl){textAreaInvalidControl.focus()} 
    }
  }

}
